/**
 * @generated SignedSource<<cfa03c17c81abf913df063dace400d79>>
 * @relayHash 988c77e477c54fe90a63d4a9bc27e2ac
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 988c77e477c54fe90a63d4a9bc27e2ac

import { ConcreteRequest } from 'relay-runtime';
export type DocumentType = "AUDIO" | "PDF" | "PHOTO" | "VIDEO";
export type FileUploadSource = "DOC2_U" | "PATIENT" | "SOFIA";
export type FileUploadStatus = "ERROR" | "HYPERLINK_PROCESSING_FAILED" | "JAVA_SCRIPT_PROCESSING_FAILED" | "MALICIOUS" | "NO_THREAT_FOUND" | "SCAN_TIMEOUT" | "UPLOADED";
export type previewDocumentFullScreenDialogMediaFilesQuery$variables = {
  id: string;
};
export type previewDocumentFullScreenDialogMediaFilesQuery$data = {
  readonly appointmentById: {
    readonly appointmentAttachments: ReadonlyArray<{
      readonly attachmentType: DocumentType;
      readonly fileName: string;
      readonly id: string;
      readonly thumbnailUrl: string | null;
      readonly uploadDate: string;
      readonly uploadSource: FileUploadSource;
      readonly uploadStatus: FileUploadStatus | null;
      readonly uploadedBy: string | null;
      readonly url: string;
    }>;
  } | null;
};
export type previewDocumentFullScreenDialogMediaFilesQuery = {
  response: previewDocumentFullScreenDialogMediaFilesQuery$data;
  variables: previewDocumentFullScreenDialogMediaFilesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "AppointmentAttachment",
  "kind": "LinkedField",
  "name": "appointmentAttachments",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "attachmentType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fileName",
      "storageKey": null
    },
    (v2/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "thumbnailUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "uploadDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "uploadedBy",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "uploadSource",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "uploadStatus",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "previewDocumentFullScreenDialogMediaFilesQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Appointment",
        "kind": "LinkedField",
        "name": "appointmentById",
        "plural": false,
        "selections": [
          (v3/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "previewDocumentFullScreenDialogMediaFilesQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Appointment",
        "kind": "LinkedField",
        "name": "appointmentById",
        "plural": false,
        "selections": [
          (v3/*:: as any*/),
          (v2/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "988c77e477c54fe90a63d4a9bc27e2ac",
    "metadata": {},
    "name": "previewDocumentFullScreenDialogMediaFilesQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "711d32bab14f052d3cdbee66d3d6708c";

export default node;
